import { z } from 'zod';

export const supportRequestSchema = z.object({
  Title: z.string().min(1),
  Priority: z.string(),
  Category: z.string(),
  For_idUser: z.number(),
  Description: z.string().min(1),
});

export type ISupportRequest = z.infer<typeof supportRequestSchema>;

export const getInitialSupportRequest = (): ISupportRequest => {
  return {
    Title: '',
    Priority: 'support-low',
    Category: 'support-support',
    For_idUser: Number(localStorage.getItem('idUser')),
    Description: '',
  };
};
